__turbopack_context__.v({
  "closeButtonWrapper": "Image-module__tC7Xtq__closeButtonWrapper",
  "container": "Image-module__tC7Xtq__container",
  "dialog": "Image-module__tC7Xtq__dialog",
  "label": "Image-module__tC7Xtq__label",
  "modal": "Image-module__tC7Xtq__modal",
  "overlay": "Image-module__tC7Xtq__overlay",
  "rounded": "Image-module__tC7Xtq__rounded",
  "zoomButton": "Image-module__tC7Xtq__zoomButton",
  "zoomIcon": "Image-module__tC7Xtq__zoomIcon",
  "zoomedImageWrapper": "Image-module__tC7Xtq__zoomedImageWrapper",
});
